<template>
<div>
<div>
<b-nav class="main-nav">
<b-nav-item class="logo">
<img src="../assets/img/logo.png"/>
</b-nav-item>
</b-nav>
</div>
<div>
<div class="main-div">
<div class="login-div">
<p>Registration process is now completed.
</p>
</div>
</div>
</div>
</div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';

export default {
  name: 'Verification',
  components: { FacitHeader },
  data() {
    return {

    };
  },
  created() {
    const query = this.$route.query;

    if (query.confirm) {
      this.confirm(query.uid, query.token);
    }
  },
  methods: {
    async confirm(uid, token) {
      try {
        await API.get(`Accounts/confirm?uid=${uid}&token=${token}`);
        this.$notify({
          group: 'sitewide',
          title: 'Success!',
          type: 'success',
          text: 'Your email has been verified',
        });
      } catch (error) {
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'There was a problem verifying your email',
        });
      }
    },
    login() {
      this.$router.push('login');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  margin-top: 20px;
  margin-left: 30px;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
  text-align: center;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.w-100 {
  width: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/verification.vue